import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { DefaultDateFormat } from "../../../helper/fixcode";

export default function ReportAssetAcknowledgementComponent() {
  const [assetAcknowledgementList, setAssetAcknowledgementList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Acknowledgement`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetAcknowledgementList(0);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetAcknowledgementList = async (assetAcknowledgeId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetAcknowledgementList(
        assetAcknowledgeId
      );
      setAssetAcknowledgementList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetAcknowledgementList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="assetRequestNo"
                    caption="Asset Request No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="assetReferenceNo"
                    caption="Asset Reference No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="assetAcknowledgeNo"
                    caption="Asset Acknowledgement No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="actionType"
                    caption="Action Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="acknowledgeDate"
                    caption="Acknowledgement Date"
                    allowFiltering={false}
                    allowSearch={true}
                    dataType="date"
                    format="dd-MMM-yyyy"
                  />
                  <Column
                    dataField="assetName"
                    caption="Asset Name"
                    allowFiltering={false}
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.assetName || ""} ${data?.assetNo || ""}`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.assetName ?? ""}</span>
                          {data?.data?.assetNo && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.assetNo ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="categoryName"
                    caption="Category"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.categoryName || ""} ${
                        data?.subCategoryName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.categoryName ?? ""}</span>
                          {data?.data?.subCategoryName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.subCategoryName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromProjectName"
                    caption="Project"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromProjectName || ""} ${
                        data?.toProjectName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromProjectName ?? ""}</span>
                          {data?.data?.toProjectName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toProjectName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromLocation"
                    caption="Transfer From/To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromLocation || ""} ${
                        data?.toLocation || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromLocation ?? ""}</span>
                          {data?.data?.toLocation && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toLocation ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromUserFullName"
                    caption="From"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromUserFullName || ""} ${
                        data?.fromDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromUserFullName ?? ""}</span>
                          {data?.data?.fromDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.fromDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="toUserFullName"
                    caption="To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.toUserFullName || ""} ${
                        data?.toDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.toUserFullName ?? ""}</span>
                          {data?.data?.toDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="transferType"
                    caption="Acknowledgement Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="assetAcknowledgeMentStatus"
                    caption="Status"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="assetConditionStatus"
                    caption="Asset Condition"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="acknowledgedDate"
                    caption="Acknowledged By"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.acknowledgedDate || ""} ${
                        data?.acknowledgedByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.acknowledgedDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.acknowledgedDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.acknowledgedDate).format(
                                  "LT"
                                ) ?? ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.acknowledgedByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetAcknowledgementList(0);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export
                    enabled={true}
                    fileName="Asset Acknowledgement Report"
                  />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
